// import slackNotify from 'slack-notify';

// const slack = slackNotify(wwfconfigs.SLACK_WEBHOOK);

// slack.onError = function (err) {
//   console.error('Slack API Error : ', err);
// };

// Couldn't get slackNotify to work hence sending message via axios straight to slack 
import axios from 'axios';

function alert(text) {
  axios.post(wwfconfigs.SLACK_WEBHOOK, {
    icon_emoji: ':warning:',
    username: 'Alert',
    text: text
  }, { headers: { "Content-Type": "multipart/form-data" } })
}
export default {
  alert
};


// WEBPACK FOOTER //
// ./src/utils/slack.js